import { useEffect, useState } from 'react';
import { DownloadSimple, X } from '@phosphor-icons/react';

const STORAGE_KEY = 'axialup-pwa-install-dismissed-at';
const DISMISS_DAYS = 14;

export default function InstallPromptBanner() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (window.matchMedia?.('(display-mode: standalone)').matches) return;  // already installed
    const dismissedAt = localStorage.getItem(STORAGE_KEY);
    if (dismissedAt) {
      const daysAgo = (Date.now() - Number(dismissedAt)) / (1000 * 60 * 60 * 24);
      if (daysAgo < DISMISS_DAYS) return;
    }
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const onInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setVisible(false);
  };

  const onDismiss = () => {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 inset-x-3 sm:bottom-6 sm:right-6 sm:left-auto sm:max-w-sm bg-gradient-to-br from-violet-600 to-fuchsia-600 text-white rounded-xl shadow-2xl p-4 z-50 flex items-start gap-3"
      data-testid="pwa-install-banner"
      role="dialog"
      aria-label="Install AxialUp"
    >
      <div className="bg-white/20 rounded-lg p-2 flex-shrink-0">
        <DownloadSimple size={22} weight="bold" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-bold text-sm">Install AxialUp on your phone</div>
        <div className="text-xs opacity-90 mt-0.5">Home screen pe icon laga lo — sara feature, fast load, offline-friendly.</div>
        <div className="flex gap-2 mt-2.5">
          <button
            onClick={onInstall}
            className="bg-white text-violet-700 font-semibold text-xs px-3 py-1.5 rounded-md hover:bg-violet-50"
            data-testid="pwa-install-btn"
          >
            Install
          </button>
          <button
            onClick={onDismiss}
            className="text-white/80 text-xs px-2 py-1.5 hover:text-white"
            data-testid="pwa-install-later"
          >
            Later
          </button>
        </div>
      </div>
      <button onClick={onDismiss} className="text-white/70 hover:text-white" aria-label="Close" data-testid="pwa-install-close">
        <X size={18} />
      </button>
    </div>
  );
}
